import * as Sentry from '@sentry/vue'
import { cloneDeep } from 'lodash'
import { createPinia } from 'pinia'
import {
  Vue,
  vuetify,
  // initSentryVue,
} from 'src/configs'
import type { ClientRenderOptions } from 'vue-compiler/types'
import { useURLStore, useContextStore } from 'src/store'
import initI18next from 'src/utils/initI18next'
import parseJson from 'src/functions/parseJson'

async function clientRender({ components }: ClientRenderOptions): Promise<void> {
  const pinia = createPinia()
  const urlStore = useURLStore(pinia)
  const contextStore = useContextStore(pinia)

  // @ts-ignore
  contextStore.$patch(state => { Object.assign(state.context, cloneDeep(window.__INITIAL_STATE__)) }) // eslint-disable-line no-underscore-dangle
  urlStore.$patch(state => {
    Object.assign(state.urls, window.__URL_STATE__) // eslint-disable-line no-underscore-dangle
    state.origin = `https://${window.__INITIAL_STATE__.request.country.site.domain}/` // eslint-disable-line no-underscore-dangle
  })

  const stateScript = document.getElementById('ssr-state')

  if (stateScript) {
    stateScript.remove()
  }

  await initI18next({
    userLanguage: contextStore.context?.current_language?.iso,
  })

  for await (const { el, componentImport } of components) { // eslint-disable-line no-restricted-syntax
    try {
      if (el) {
        const props = parseJson(el.getAttribute('data-ssr-props'))
        const { default: component } = await componentImport()
        const app = new Vue({
          // eslint-disable-next-line no-underscore-dangle
          name: component.__name || component.name,
          pinia,
          vuetify,
          render: h => h(component, { props }),
        })

        app.$mount(el)

        // initSentryVue(app)
      }
    } catch (error: any) {
      console.log(`Рендер Vue на клиенте упал! ${error?.message}`) // eslint-disable-line
      Sentry.captureException(new Error(`Рендер Vue на клиенте упал! ${error?.message}`))
    }
  }
}

export default clientRender
